import React, { useState } from 'react';
import { showGlobalToast } from '../../components/ui';
import { errMsg } from '../../utils/format';
import api from '../../utils/api';
import { useAuth } from '../../context/AuthContext';

export default function Profile() {
  const { user, refreshUser } = useAuth();
  const [info, setInfo] = useState({ fullName: user?.fullName || '', phone: user?.phone || '' });
  const [pw, setPw] = useState({ currentPassword:'', newPassword:'', confirm:'' });
  const [savingInfo, setSavingInfo] = useState(false);
  const [savingPw, setSavingPw] = useState(false);
  const [pwError, setPwError] = useState('');

  const saveInfo = async (e) => {
    e.preventDefault(); setSavingInfo(true);
    try {
      await api.patch('/api/auth/me', { fullName: info.fullName, phone: info.phone });
      if (refreshUser) await refreshUser();
      showGlobalToast('Profile updated');
    } catch(err) { alert(errMsg(err)); }
    finally { setSavingInfo(false); }
  };

  const savePw = async (e) => {
    e.preventDefault(); setPwError('');
    if (pw.newPassword !== pw.confirm) { setPwError('Passwords do not match'); return; }
    setSavingPw(true);
    try {
      await api.post('/api/auth/change-password', { currentPassword: pw.currentPassword, newPassword: pw.newPassword });
      setPw({ currentPassword:'', newPassword:'', confirm:'' });
      showGlobalToast('Password changed');
    } catch(err) { setPwError(errMsg(err)); }
    finally { setSavingPw(false); }
  };

  return (
    <div>
      <div className="page-header"><h1>My Profile</h1></div>
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:16, maxWidth:760 }}>

        {/* Profile info */}
        <div className="card">
          <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', fontWeight:600, fontSize:13 }}>
            Contact information
          </div>
          <form onSubmit={saveInfo} style={{ padding:16 }}>
            <div className="form-group">
              <label>Full name</label>
              <input value={info.fullName} onChange={e => setInfo(f=>({...f, fullName:e.target.value}))} />
            </div>
            <div className="form-group">
              <label>Email</label>
              <input value={user?.email || ''} disabled style={{ background:'var(--bg-secondary)' }} />
              <small style={{ fontSize:11, color:'var(--text-tertiary)' }}>Contact an admin to change your email</small>
            </div>
            <div className="form-group">
              <label>Phone</label>
              <input type="tel" placeholder="e.g. (330) 730-4698" value={info.phone} onChange={e => setInfo(f=>({...f, phone:e.target.value}))} />
            </div>
            <button className="btn btn-primary btn-sm" type="submit" disabled={savingInfo}>
              {savingInfo ? 'Saving…' : 'Save changes'}
            </button>
          </form>
        </div>

        {/* Change password */}
        <div className="card">
          <div style={{ padding:'12px 16px', borderBottom:'1px solid var(--border)', fontWeight:600, fontSize:13 }}>
            Change password
          </div>
          <form onSubmit={savePw} style={{ padding:16 }}>
            {pwError && <div className="alert alert-danger" style={{ marginBottom:12 }}>{pwError}</div>}
            <div className="form-group">
              <label>Current password</label>
              <input type="password" required value={pw.currentPassword} onChange={e => setPw(f=>({...f, currentPassword:e.target.value}))} />
            </div>
            <div className="form-group">
              <label>New password</label>
              <input type="password" required minLength={8} value={pw.newPassword} onChange={e => setPw(f=>({...f, newPassword:e.target.value}))} />
              <small style={{ fontSize:11, color:'var(--text-tertiary)' }}>Min 8 chars, 1 uppercase, 1 number</small>
            </div>
            <div className="form-group">
              <label>Confirm new password</label>
              <input type="password" required value={pw.confirm} onChange={e => setPw(f=>({...f, confirm:e.target.value}))} />
            </div>
            <button className="btn btn-primary btn-sm" type="submit" disabled={savingPw}>
              {savingPw ? 'Saving…' : 'Change password'}
            </button>
          </form>
        </div>

      </div>
    </div>
  );
}
